import React, { createContext, useEffect, useMemo, useState } from 'react';
import { parseJwt, extractUserFromToken, isTokenExpired } from '../utils/jwt';
import { STORAGE_KEYS } from '../utils/constants';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) || '');
  const [user, setUser] = useState(() => extractUserFromToken(token));

  useEffect(() => {
    if (token && isTokenExpired(token)) {
      setToken('');
      return;
    }

    if (token) {
      localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token);
      setUser(extractUserFromToken(token));
    } else {
      localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
      setUser(null);
    }
  }, [token]);

  const isAuthenticated = !!token;
  const isAdmin = user?.role === 'Admin';

  const login = (authToken) => {
    if (!authToken) return;
    const parsed = parseJwt(authToken);
    if (!parsed || isTokenExpired(authToken)) {
      return;
    }
    setToken(authToken);
  };

  const logout = () => {
    setToken('');
  };

  const value = useMemo(
    () => ({
      token,
      user,
      isAuthenticated,
      isAdmin,
      login,
      logout
    }),
    [token, user, isAuthenticated, isAdmin]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
